import { render, staticRenderFns } from "./CartView.vue?vue&type=template&id=6b59662c&scoped=true&"
import script from "./CartView.vue?vue&type=script&lang=js&"
export * from "./CartView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b59662c",
  null
  
)

export default component.exports